import * as Sentry from '@sentry/react';
import { Route, Routes } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import { Signup } from 'components/Signup/Signup';
import { Landing } from 'components/Landing';
import { ProtectedRoute } from 'components/ProtectedRoute';
import ThirdPartyScripts from 'Marketing/ThirdPartyScripts';
import { LoginRoutes } from 'components/Login/Routes';
import { usePageTracking } from 'utils/adobeAnalytics/hooks/usePageTracking';
import { ThemeInjector } from '@veeqo/ui';
import { DynamicHead } from 'components/DynamicHead';
import { OnRouteChange } from 'components/OnRouteChange';
import { VQ_SC_ROUTE_LIST } from 'scPaths';
import { TranslationProvider } from 'context/TranslationContext';
import { VQMetrics } from './components/Landing/utils/vqMetrics';

// Initialize metrics instance for global use
window.vqMetrics = new VQMetrics(false);

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  usePageTracking();

  const seCeRoutes = VQ_SC_ROUTE_LIST.map(({ prefix, path, vqHost, contentStyle, entryType }) => (
    <Route
      path={`${prefix}${path}`}
      key={`${prefix}${path}`}
      element={
        <ProtectedRoute vqHost={vqHost}>
          <Landing colorVariant="blue" contentStyle={contentStyle} entryType={entryType} footer />
        </ProtectedRoute>
      }
    />
  ));

  return (
    <TranslationProvider>
      <DynamicHead />
      <OnRouteChange />
      <ThirdPartyScripts />
      <ThemeInjector />
      <AnimatePresence mode="wait" initial={false}>
        <SentryRoutes key="Signup App">
          <Route path="/signin/*" Component={LoginRoutes} />
          <Route path="/signup/*" element={<Signup />} />
          <Route path="/vq/sc/signin/*" element={<LoginRoutes />} />
          <Route path="/vq/signup/*" element={<Signup />} />
          <Route path="/vq/sc/signup/*" element={<Signup />} />
          {seCeRoutes}
        </SentryRoutes>
      </AnimatePresence>
    </TranslationProvider>
  );
}

export default App;
